import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const DataSourcesWrapper = styled(Box).attrs({
  align: 'center',
  width: '100%',
})``;
export const DataSourcesContainer = styled(Box).attrs({
  width: 750,
})`
  max-width: 100%;
`;
export const DataSourcesHeader = styled(Text).attrs({
  size: 'header',
  fontWeight: 'semibold',
  mb: 20,
  color: 'primaryText',
})``;
